<template>
  <div class="control has-icons-left">
    <div class="select">
      <select v-model="value" :disabled="isReportLoading">
        <option v-for="range of dateOptions" :key="range.label" :value="range">{{ range.label }}</option>
      </select>
      <span class="icon is-left select-icon">
        <CalendarIcon class="icon-1-3x dropdown-icons icon-adjustment flow-icon-adjustment" />
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { DatePicker } from '@/features/reports/services';
import { SET_REPORTING_DATE_RANGE } from '@/store/reports/mutationTypes';
import { DateOption } from '@/features/reports/models';
import CalendarIcon from 'vue-material-design-icons/CalendarRange.vue';
import { useStore } from 'vuex';
import { computed, onMounted, ref, watch } from 'vue';

const store = useStore();
const selectedDateOption = computed(() => store.getters.selectedDateOption);
const isReportLoading = computed(() => store.getters.isReportLoading);
const setReportingDateRange = (dateOption: DateOption) => store.commit(SET_REPORTING_DATE_RANGE, dateOption);

const value = ref(DatePicker.monthOptions.thisMonth);

onMounted(() => (value.value = findMatchingValue(selectedDateOption.value) ?? DatePicker.options.thisMonth));
watch(value, (newValue) => setReportingDateRange(newValue));

function findMatchingValue(value: DateOption): DateOption | undefined {
  return dateOptions.value.find(
    (option) =>
      option.getDateRange().start.getTime() === value.getDateRange().start.getTime() &&
      option.getDateRange().end.getTime() === value.getDateRange().end.getTime(),
  );
}

const dateOptions = ref<DateOption[]>(
  DatePicker.monthOptions
    .toArray()
    .filter((m) => m.getDateRange().end.getFullYear() > 2021)
    .sort((a, b) => {
      const aIsNumeric = !isNaN(parseInt(a.label, 10));
      const bIsNumeric = !isNaN(parseInt(b.label, 10));
      if (aIsNumeric && bIsNumeric) {
        return parseInt(b.label, 10) - parseInt(a.label, 10);
      }
      if (aIsNumeric || bIsNumeric) {
        return -1;
      }
      return 0;
    }),
);
</script>

<style lang="scss" scoped>
.select {
  margin-left: 20px;

  select {
    min-width: 300px;
  }
}

.flow-select--disabled {
  opacity: 0.5;

  select[disabled] {
    background-color: #ffffff;
    opacity: 1;
  }
}

.icon-adjustment {
  margin-left: -10px;
  margin-top: -4px;
}
</style>
